// extracted by mini-css-extract-plugin
export default {"container":"activity-item_container__N0Gxb","date":"activity-item_date__RDY3g","position":"activity-item_position__X9utp"};